import i18n from "i18next";

import { initReactI18next } from "react-i18next";

import da_DK from "./da_DK";
import de_DE from "./de_DE";
import en_GB from "./en_GB";
import en_US from "./en_US";
import es_ES from "./es_ES";
import fi_FI from "./fi_FI";
import fr_FR from "./fr_FR";
import nb_NO from "./nb_NO";
import nl_NL from "./nl_NL";
import sv_SE from "./sv_SE";

i18n.use(initReactI18next).init({
  ns: ["AS"],
  defaultNS: "AS",
  debug: true,
  fallbackLng: "de-DE",
  interpolation: {
    escapeValue: false,
  },
  resources: {
    "de-DE": de_DE,
    "en-US": en_US,
    "en-GB": en_GB,
    "es-ES": es_ES,
    "fi-FI": fi_FI,
    "fr-FR": fr_FR,
    "nb-NO": nb_NO,
    "nl-NL": nl_NL,
    "sv-SE": sv_SE,
    "da-DK": da_DK,
  },
});

export default i18n;
